<template>
    <div>
        <modal class="new-modal-default reject-popup" :name="modal_name" transition="nice-modal-fade" :delay="100" :width="500"
            :height="325" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">REASON FOR REJECTION</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="closeModal"></span>
                    </div>
                </div>
                <div class="v-modal-body pb-0" style="height:auto;">
                    <div class="v-modal-layout px-2">
                        <div class="mt-4">
                            <textarea-autosize class="bg-transparent px-2 pt-1 pb-6 mt-1 description" name="description" v-validate="'required'" v-model="description"
                                placeholder="Enter Reason for Rejection"
                                :min-height="100"
                                :max-height="100"
                                maxlength="1000"/>
                        </div>
                        <div class="d-flex justify-content-end">
                            <!-- <div>
                                <input type="checkbox" id="include_signature" name="vehicle1" value="Signature">
                                <label for="Signature"> Add My Signature</label>
                            </div> -->
                            <div>
                                <span>{{ description.length }}/1000</span>
                            </div>
                        </div>
                        <div class="text-right pr-10">
                            <span class="float-left text-danger mb-3" v-show="errors.has('description')">Add Reason for Rejection</span>
                        </div>
                    </div>
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="v-modal-dialog-actions d-flex justify-content-center align-items-center pt-0">
                    <button class="btn new-cancel-button ml-2 mr-2" @click="closeModal">Cancel</button>
                    <button class="btn new-save-button ml-2 mr-2" @click="confirmReject()">Send</button>
                </div>
                <div v-else class="v-modal-dialog-actions d-flex justify-content-center align-items-center pt-0" style="position: relative;">
                    <button class="btn btn-des-small ml-2 mr-2 btn-new-cancel" style="border: 1px transparent;" disabled>Cancel</button>
                    <button class="btn btn-des-small ml-2 mr-2 btn-new-save" style="border: 1px transparent;" disabled>Send</button>
                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 115% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    props: ["modal_name"],
    data(){
        return {
            disableButtonAndDisplayLoader: false,
            description: "",
        }
    },
    components: {
        HollowDotsSpinner
    },
    methods: {
        closeModal() {
            this.$emit("cancelReject");
        },
        confirmReject() {
            this.$validator.validateAll().then(result =>{
                if(result){
                    this.disableButtonAndDisplayLoader = true;
                    this.$emit("rejectCampaigns", this.description);
                }
            });
        }
    }
}
</script>
<style scoped>
    .btn-new-cancel {
        color: #fff;
        background-color: #E64646;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #E64646;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .description{
        border: solid 1px #000 !important;
        border-radius: 5px!important;
        text-transform: capitalize;
        color: #000000;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/alertModals/RejectCampaign.vue